__turbopack_context__.v({
  "globeIcon": "navigation-module-scss-module__Upnnzq__globeIcon",
  "languageSelector": "navigation-module-scss-module__Upnnzq__languageSelector",
  "logo": "navigation-module-scss-module__Upnnzq__logo",
  "menuIcon": "navigation-module-scss-module__Upnnzq__menuIcon",
  "menuItemActive": "navigation-module-scss-module__Upnnzq__menuItemActive",
  "navContent": "navigation-module-scss-module__Upnnzq__navContent",
  "navLinks": "navigation-module-scss-module__Upnnzq__navLinks",
  "navText": "navigation-module-scss-module__Upnnzq__navText",
  "navigation": "navigation-module-scss-module__Upnnzq__navigation",
});
